import {
  EditSettingsModel,
  FilterSettingsModel,
  PageSettingsModel,
} from '@syncfusion/ej2-react-grids';
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import React, { Component } from 'react';
import Message from '../../utils/Message/Message';
import './style.css';
import {
  DropDownList,
  DropDownListComponent,
} from '@syncfusion/ej2-react-dropdowns';
import { ThemeContext } from '../../context/theme.context';
import GlobalGrid from '../../components/GlobalGrid';
import { BsSearch } from 'react-icons/bs';
import { DataManager, ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import { all_information, loadingShow } from '../../App';
import { getBusinessLogicConfiguration } from '../../services/Dig/BusinessLogicConfiguration/BusinessLogicConfigurationServices';
import './style.css';
interface IState {
  current_query: string;
  loadSignal: boolean;
  searchText: string;
}
interface IProps {
  isSchedulerSide?: boolean;
  outter_asset_code?: string | undefined;
  outter_order_code?: string | undefined;
}

export class OrderAttachments extends Component<IProps, IState> {
  private current_query = '';
  private theQueryOutterAsset = '';
  private theQueryOutterOrder = '';
  private theQuerySearch = '';
  private theQueryPlanId = '';
  private plan_id: number = 0;
  private order_code: string | undefined = undefined;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private orderElem: any;
  private orderObj: any;
  private orderDatasource: DataManager;
  private queryOforder = new Query().take(20);
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      current_query: '',
      loadSignal: false,
      searchText: '',
    };
    this.orderDatasource = new DataManager({
      adaptor: new ODataV4Adaptor(),
      crossDomain: true,
      url: process.env.REACT_APP_API_GLOBAL_URL + `order/get-limit-order`,
    });
  }

  toolbarClickExtends(args: any) {
    if (args.item.id === 'refresh') {
      loadingShow(true,"Loading...")
    }}
  template = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          alignSelf: 'flex-end',
          height: 25,
        }}
      >
        <TextBoxComponent
          type={'text'}
          id='work_orders'
          autocomplete='off'
          input={this.inputEnterPress.bind(this)}
          showClearButton
          placeholder='Search'
          onChange={(args: any) => {
            this.setState({ searchText: args.target.value });
          }}
        />
        <div
          style={{
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            borderBottomColor: 'transparent',
          }}
        >
          <BsSearch className={'searchIcon'} onClick={this.search.bind(this)} />
        </div>
      </div>
    );
  };
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    { template: this.template.bind(this), align: 'Right' },
  ];

  
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: true,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  inputEnterPress(e: any) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      this.search();
    }
  }
  getLogicConfiguration() {
    getBusinessLogicConfiguration({ org_id: all_information.company_id })
      .then((el) => {
        this.current_query = '';
        el.data.map((elin: any) => {
          if (
            elin.target_table === 'uw_order' &&
            elin.component_name === 'Cloud Planner'
          ) {
            this.current_query += elin.condition + ' and';
          }
        });
      })
      .catch((er) => {
        //("Can't acces business logic parameter");
        Message.error("Can't acces business logic parameter");
        if (er.response) {
          Message.error(
            er.response.data +
              '\n' +
              er.response.status +
              '\n' +
              er.response.headers
          );
        } else if (er.request) {
          Message.error(er.request);
        } else {
          Message.error('Error: ' + er.message);
        }
        Message.error(er.config);
        this.buildQuery();
      });
  }
  orderParams = {
    create: () => {
      this.orderElem = document.createElement('input');
      return this.orderElem;
    },
    destroy: () => {
      this.orderObj.destroy();
    },
    read: () => {
      return this.orderObj.text;
    },
    write: (args: any) => {
      this.orderObj = new DropDownList({
        change: () => {},
        dataSource: this.orderDatasource,
        query: this.queryOforder,
        fields: { text: 'order_code', value: 'order_code' },
        floatLabelType: 'Never',
        placeholder: 'Select a Order',
        allowFiltering: true,
        value: args.rowData.orderCode,
        filtering: this.onFiltering.bind(this),
      });
      this.orderObj.appendTo(this.orderElem);
    },
  };
  onFiltering = (e: any) => {
    let query = new Query().take(20);
    query = e.text !== '' ? query.where('order_code', 'equal', e.text) : query;
    e.updateData(this.orderDatasource, query);
  };
  componentDidMount() {
    this.plan_id = this.context?.planId;
    this.order_code = this.props.outter_order_code;
    this.buildQuery();
  }
  search() {
    if (this.state.searchText !== '' || this.current_query !== '') {
      this.buildQuery();
    }
  }
  buildQuery() {
    this.current_query = this.state.current_query.trimEnd();
    this.current_query = this.current_query.replace(
      this.theQueryOutterAsset,
      ''
    );
    this.current_query = this.current_query.replace(this.theQuerySearch, '');
    this.current_query = this.current_query.replace(this.theQueryPlanId, '');
    this.current_query = this.current_query.replace(
      this.theQueryOutterOrder,
      ''
    );
    var o_asset_code = this.props.outter_asset_code;
    var o_order_code = this.props.outter_order_code;
    this.theQuerySearch = '';
    this.theQueryOutterAsset = '';
    if (this.plan_id !== 0) {
      if (this.current_query !== '') {
        this.theQueryPlanId = this.addToQuery(
          'plan_id',
          '=',
          'andWhere',
          this.plan_id?.toString(),
          this.theQueryPlanId
        );
      } else {
        this.theQueryPlanId = this.addToQuery(
          'plan_id',
          '=',
          'where',
          this.plan_id?.toString(),
          this.theQueryPlanId
        );
      }
    }
    if (o_order_code !== '' && o_order_code !== undefined) {
      if (this.current_query !== '') {
        this.theQueryOutterOrder = this.addToQuery(
          'order_code',
          '=',
          'andWhere',
          o_order_code.trim(),
          this.theQueryOutterOrder
        );
      } else {
        this.theQueryOutterOrder = this.addToQuery(
          'order_code',
          '=',
          'where',
          o_order_code.trim(),
          this.theQueryOutterOrder
        );
      }
    }
    if (o_asset_code !== '' && o_asset_code !== undefined) {
      if (this.current_query !== '') {
        this.theQueryOutterAsset = this.addToQuery(
          'asset_code',
          'in',
          'andWhere',
          o_asset_code.trim(),
          this.theQueryOutterAsset
        );
      } else {
        this.theQueryOutterAsset = this.addToQuery(
          'asset_code',
          'in',
          'where',
          o_asset_code.trim(),
          this.theQueryOutterAsset
        );
      }
    }
    if (this.state.searchText !== '') {
      this.theQuerySearch = '$' + this.state.searchText;
      this.current_query = this.current_query + this.theQuerySearch;
    }
    this.setState({
      current_query: this.current_query + ' ',
      loadSignal: true,
    });
  }
  addToQuery = (
    field: string,
    c: string,
    type: string,
    v: string,
    current_query: string
  ) => {
    current_query = JSON.stringify({
      f: field,
      c: c,
      t: type,
      v: v,
    });
    current_query += '?';
    this.current_query += current_query;
    return current_query;
  };
  PathTemplateResources(args: any) {
    let path = args.docuPath;
    if (!args.docuPath.includes('http')) {
      path = 'https://' + path;
    }
    return (
      <a href={path} target='_blank'>
        {path}
      </a>
    );
  }
  theColumns = [
    {
      field: 'id',
      headerText: 'ID',
      textAlign: 'Left',
      allowEditing: false,
      visible: false,
      isPrimaryKey: true,
    },
    {
      field: 'dataSource',
      headerText: 'Data Source',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'sourceObject',
      headerText: 'Source Object',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'orderCode',
      headerText: 'Order Code',
      textAlign: 'Left',
      allowEditing: true,
      edit: this.orderParams,
    },
    {
      field: 'docuSeq',
      headerText: 'Seq',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'docuType',
      headerText: 'Type',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'docuDescription',
      headerText: 'Description',
      textAlign: 'Left',
      allowEditing: true,
    },
    {
      field: 'docuPath',
      headerText: 'Path',
      textAlign: 'Left',
      template: this.PathTemplateResources.bind(this),
      allowEditing: true,
    },
  ];
  render() {
    return (
      <div>
        <GlobalGrid
          id='cloud-planner-workorders'
          columns={this.theColumns}
          height={'calc(-290px + 100vh)'}
          query={this.state.current_query}
          toolbarOptions={this.toolbarOptions}
          additinalToolbarClick={this.toolbarClickExtends.bind(this)}
          get_query={'order-attachments'}
          delete_query={'order-attachments/delete'}
          edit_query={'order-attachments/edit'}
          add_query={'order-attachments/create'}
          signalOfLoad={this.state.loadSignal}
          theEditOptions={this.editOptions}
        />
      </div>
    );
  }
}

export default OrderAttachments;
